<template>
    <v-autocomplete v-model="selectedItems"
                    :items="items"
                    deletable-chips
                    multiple
                    :return-object="true"
                    :loading="loading"
                    :search-input.sync="search"
                    no-filter
                    :label="$t('search', {subject: $t('travel.menu.similarTrips') })"
                    item-value="id"
                    item-text="name"
                    small-chips>
        <template v-slot:no-data>
            <v-list-item>
                <v-list-item-title>Start typing to search for trips by code or by name</v-list-item-title>
            </v-list-item>
        </template>
        <template v-slot:item="{item}">
            <v-list-item-content>
                <v-list-item-title>
                    {{item.name}} ({{(item.extCode ? item.ext : item.code)}})
                </v-list-item-title>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
    import {mapActions} from "vuex";
    import {TripAction} from "../../store/trips/types";
    import axios from "axios";
    import {debounce} from "debounce";

    export default {
        data: () => ({
            loading: false,
            search: null,
            items: [],
        }),
        props: {
            value: {
                type: Array,
                required: true,
            },
        },
        mounted() {
            this.querySelectionsDebounce = debounce(this.querySelections, 500);
        },
        watch: {
            selectedItems: {
                handler(selectedItems) {
                    this.$emit('input', selectedItems);
                },
            },
            search(val) {
                val && this.querySelectionsDebounce(val);
            },
        },
        computed: {
            selectedItems: {
                get() {
                    return this.value;
                },
                set(selectedItems) {
                    this.$emit('input', selectedItems);
                },
            }
        },
        methods: {
            ...mapActions({
                load: `trips/${TripAction.AUTOCOMPLETE}`,
            }),
            querySelections(val) {
                this.loading = true;

                axios.post('/trip/autocomplete', {'search': val})
                    .then(resp => {
                        return resp.data;
                    })
                    .then(data => {
                        this.items = data;
                        console.log(this.items);
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },
    }
</script>